<template>
    <div
        class="sound-buttons"
        :class="[
            missing ? 'missing' : '',
            muted ? 'off' : 'on',
            mobile ? 'mobile-viewer' : ''
        ]"
        title="Play/Pause Music"
        @click="toggleMusic()"
    >
        <div class="soundbars">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
    import {
        Howl,
        Howler // eslint-disable-line no-unused-vars
    } from 'howler';

    import {
        isMobile
    } from 'mobile-device-detect';

    export default {
        name: 'howling', // eslint-disable-line vue/component-definition-name-casing
        props: {
          audio: {
            type: String,
            default: '',
            required: true
          }
        },
        data() {
            return {
                mobile: isMobile,
                muted: false,
                missing: true,
                sound: {}
            };
        },
        mounted() {
            const self = this;
            self.missing = self.audio === '';
            self.sound = new Howl({
                src: [`/static/audio/${self.audio}`],
                autoplay: true,
                loop: true
            });
        },
        methods: {
            toggleMusic () {
                const self = this;
                if (self.sound.playing()) {
                    self.muted = true;
                    self.sound.pause();
                }
                else {
                    self.muted = false;
                    self.sound.play();
                }
                return;
            }
        }
    };
</script>

<style scoped>
    /* stylelint-disable order/properties-alphabetical-order */
    .sound-buttons {
        @mixin position fixed, auto, 1em, 1em, auto;
        align-items: center;
        background-color: color-mod(var(--color-black) alpha(25%));
        border-radius: 100%;
        cursor: pointer;
        display: flex;
        flex-flow: column;
        height: 2.6em;
        justify-content: center;
        padding: 2px;
        width: 2.6em;
        z-index: var(--z-index-max);

        &.missing,
        &.mobile-viewer {
            display: none;
        }

        .soundbars {
            display: flex;
            height: 1em;
            position: relative;
            transform: translateZ(101px);
            width: 1em;
        }

        .soundbars div {
            flex: 1;
            height: 100%;
            position: relative;

            &::after {
                @mixin position absolute, auto, auto, 0, 25%;
                background: var(--color-white);
                content: '';
                display: block;
                height: 100%;
                transform: scaleY(10%);
                transform-origin: 0 100%;
                -webkit-animation-name: soundbaroff;
                animation-name: soundbaroff;
                -webkit-animation-iteration-count: 1;
                animation-iteration-count: 1;
                -webkit-animation-direction: alternate;
                animation-direction: alternate;
                width: 50%;
            }

            &:nth-child(0n+1)::after {
                -webkit-animation-duration: .5s;
                animation-duration: .5s;
            }

            &:nth-child(2)::after {
                -webkit-animation-duration: .54s;
                animation-duration: .54s;
            }

            &:nth-child(3)::after {
                -webkit-animation-duration: .47s;
                animation-duration: .47s;
            }

            &:nth-child(4)::after {
                -webkit-animation-duration: .46s;
                animation-duration: .46s;
            }

            &:nth-child(5)::after {
                -webkit-animation-duration: .53s;
                animation-duration: .53s;
            }
        }

        &.on .soundbars div::after {
            -webkit-animation-name: soundbar;
            animation-name: soundbar;
            -webkit-animation-iteration-count: infinite;
            animation-iteration-count: infinite;
            -webkit-animation-direction: alternate;
            animation-direction: alternate;
        }

        &.off .soundbars div::after {
            -webkit-animation-name: soundbaroff;
            animation-name: soundbaroff;
            -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
            -webkit-animation-direction: alternate;
            animation-direction: alternate;
        }
    }
    /* stylelint-enable order/properties-alphabetical-order */
    .no-touch .sound-button:hover #soundbars div::after {
        background: var(--color-white);
    }

    @-webkit-keyframes soundbarOff {
        100% {
            transform: scaleY(.1);
        }
    }

    @-webkit-keyframes soundbar {
        0% {
            transform: scaleY(.01);
        }

        100% {
            transform: scaleY(1);
        }
    }

    @keyframes soundbarOff {
        100% {
            transform: scaleY(.1);
        }
    }

    @keyframes soundbar {
        0% {
            transform: scaleY(.01);
        }

        100% {
            transform: scaleY(1);
        }
    }
</style>
